import React from 'react';
import { ListGroup, ListGroupItem, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import moment from 'moment-timezone';
import './TimesheetNav.css';

import DatePickerEnhanced from './TimesheetDatePickerEnhanced';

const TimesheetNav = (props) => {
  const {
    weeklyTimesheetSummaries, dispatchSelectTimesheetDate,
    currentSelectedTimesheetDate, timeZone,
  } = props;

  return (
    <div className="panel panel-default">
      <div className="panel-heading">
        <div className="panel-title">
          <Row>
            <Col md={6}>
              <span className="pull-left">Nav</span>
            </Col>
            <Col md={6}>
              <div className="pull-right">
                <DatePickerEnhanced />
              </div>
            </Col>
          </Row>
        </div>

      </div>
      <div className="panel-body">
        <ListGroup className="col-md-12 app-remove-right-padding">

          {weeklyTimesheetSummaries.map((timesheet) => {
            const key = timesheet.id;
            const startTimesheetDate = moment.tz(timesheet.start_date.iso8601, timeZone);
            const endTimesheetDate = moment.tz(timesheet.start_date.iso8601, timeZone).add(6, 'days');
            const selectedDate = moment.tz(currentSelectedTimesheetDate, timeZone);

            const leftSide = moment(selectedDate).isSameOrAfter(startTimesheetDate);
            const rightSide = moment(selectedDate).isSameOrBefore(endTimesheetDate);

            const isActive = (leftSide && rightSide);
            return (
              <ListGroupItem
                className={`timesheetNav-past-hours list-group-item ${isActive ? 'active' : ''}`}
                key={key}
                onClick={() => {
                  return dispatchSelectTimesheetDate(timesheet.start_date.iso8601);
                }}
              >
                <div>
                  <label className="timesheetNav-pointer">
                    Week of: { timesheet.start_date.display }
                  </label>
                </div>
                <div>
                  <label className="timesheetNav-pointer">
                    Total Hours: {timesheet.total_hours.to_string}
                  </label>
                </div>
              </ListGroupItem>
            );
          })}
        </ListGroup>
      </div>
    </div>
  );
};

TimesheetNav.propTypes = exact({
  // eslint-disable-next-line react/forbid-prop-types
  weeklyTimesheetSummaries: PropTypes.array.isRequired,
  dispatchSelectTimesheetDate: PropTypes.func.isRequired,

  /* eslint-disable react/no-unused-prop-types */
  /* Query variable props */
  userId: PropTypes.number.isRequired,
  originDate: PropTypes.string.isRequired,
  periods: PropTypes.number.isRequired,

  currentSelectedTimesheetDate: PropTypes.string.isRequired,
  timeZone: PropTypes.string.isRequired,
  /* eslint-enable react/no-unused-prop-types */
});

export default TimesheetNav;
